// Cart upsell buttons (snippets/dg-cart-upsell.liquid): add the bundle accessories, then let the
// cart drawer / cart page re-render from the returned sections, like the product page does.
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

document.addEventListener('click', async (event) => {
  const btn = event.target.closest('[data-dg-upsell-add]');
  if (!btn || btn.disabled) return;
  btn.disabled = true;
  btn.classList.add('is-loading');

  const bundle = btn.dataset.bundle;
  const items = btn.dataset.items.split(',').filter(Boolean).map((pair) => {
    const [id, quantity] = pair.split(':').map(Number);
    return { id, quantity, properties: { Bundle: bundle } };
  });
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);

  const deferred = CartLinesUpdateEvent.createPromise();
  btn.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
      promise: deferred.promise,
    })
  );

  try {
    const added = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      body: JSON.stringify({ items, sections: sectionIds.join(',') }),
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    }).then((r) => r.json());
    const cart = await fetch(Theme.routes.cart_url + '.js').then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        sections: added.sections,
        didError: Boolean(added.status),
        source: 'dg-cart-upsell',
        itemCount: items.reduce((n, i) => n + i.quantity, 0),
      },
    });
    if (added.status) window.location.reload();
  } catch (error) {
    deferred.reject(error);
    window.location.reload();
  }
});

// OZ-GIFT-1024: the free blankets come with the bed (one pack per bed). If the bed quantity drops,
// bring the gift line down to match so the customer is never charged for it.
const BED = 'jumbo-orthopedic-dog-bed';
const GIFT = 'plush-dog-blankets-3-pack';
let syncing = false;
async function syncGift() {
  if (syncing) return;
  syncing = true;
  try {
    const cart = await fetch(Theme.routes.cart_url + '.js').then((r) => r.json());
    const beds = cart.items.filter((i) => i.handle === BED).reduce((n, i) => n + i.quantity, 0);
    const gift = cart.items.find((i) => i.handle === GIFT && i.properties && i.properties['Free gift']);
    if (!gift || gift.quantity <= beds) return;
    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'change',
        context: 'cart',
        lines: [{ merchandiseId: String(gift.variant_id), quantity: beds }],
        promise: deferred.promise,
      })
    );
    const changed = await fetch(Theme.routes.cart_change_url, {
      method: 'POST',
      body: JSON.stringify({ id: gift.key, quantity: beds, sections: sectionIds.join(',') }),
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    }).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(changed),
      detail: { items: changed.items, sections: changed.sections, source: 'dg-gift-sync', itemCount: changed.item_count },
    });
  } catch (error) {
    // Leave the cart as it is; the checkout still shows the real price.
  } finally {
    syncing = false;
  }
}
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (event.detail?.source === 'dg-gift-sync') return;
  event.promise?.then(syncGift).catch(() => {});
});
syncGift();
